<template lang="pug">
  .crud
    modal-import(model="lot" :title="$t('front.import_modal', {model: $t('strings.lot')})")
    modal-lots(:newRecord='newRecord', :is-add='isModalAdd')
    modal-lots-many(:ids='ids' :map_id='map_id' :page='this.currentPage' @reset="resetSelect")
    modal-images-lots(:form='form', :title="$t('strings.add_images')")
    Loader
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.lots') }}:
            span {{ $t('strings.description', {attribute: $t('strings.lots')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          vm-select(v-model='map_id')
            vm-select-item(:key='index' :value='item.id' :text='item.title' v-for='item,index in maps')
          div
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="editMany" :disabled="!enabledEdit" v-if="$auth.check('Admin')")
                    vm-icon(icon="edit-outline")
                    slot &nbsp;{{ $t('strings.edit') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="deleteLotsConfirm" :disabled="true")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="setModalImportVisible(true)")
                    vm-icon(icon="upload-outline")
                    slot &nbsp;{{ $t('strings.import') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(multiple v-model="selected" max-height="350px" :data="lots")
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)"  width="300px")
                div
                  vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('lots.'+ item)")
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref='dropdown' vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex-flex-column.justify-content-between.position-relative
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                          vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Frente esq" v-model="filters.whereIn.park")
                            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in park")
                          vm-select.filter(type="date" :placeholder="$t('strings.multiple')"  multiple autocomplete label="Modelo" v-model='filters.whereIn.category_name')
                            vm-select-item(:key="index" :value="item.title" :text="item.title" v-for="(item,index) in categoriesCatalog")
                          vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                          vm-select.filter(:placeholder="$t('strings.multiple')" autocomplete label="Completion Date" v-model="filters.where.completion_date")
                            vm-select-item(:key="index" :value="item" :text="item" v-for="(item,index) in dateComplete")
                          vm-select.filter(:placeholder="$t('strings.multiple')" autocomplete label="Excedente" v-model="filters.whereBetween.square_meter")
                            vm-select-item(:key="index" :value="item" :text="item" v-for="(item,index) in ranger")
                        //- vm-select.filter(url="customers" columns="tradename,etc" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('sales.customer_id')" v-model="filters.whereIn.customer_id" @input-change="autoCompleteFunc")
                          vm-select-item(:key="index" :value="item.id" :text="item.tradename" v-for="(item,index) in lotsCatalog.customers")
                        //- vm-date-picker.filter(type="daterange" :label="$t('lots.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")

                            //- NOTA: (agregar clase .filter)
                        .filter.d-flex
                          vm-button(@click="setFilters()") {{ $t('strings.apply') }}
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)")
            template(slot="thead")
              vm-th(:key="index" v-for="(column, index) in columns") {{ $t('lots.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
                  slot(v-if="column != 'status' && column != 'description' && column != 'image' && column != 'park'") {{data[indextr][column]}}
                  slot(v-if="column === 'description'") {{ stripHTML(data[indextr][column]) }}
                  slot(v-if="column === 'park'")
                    toggle-button(:value='!!data[indextr][column]' :sync='true' @change="inCorner(data[indextr])" v-if="!$auth.check('User')")
                    slot(v-if="$auth.check('User')") {{data[indextr]['park_display']}}
                  //- a(v-if="column === 'image' && data[indextr][column]" :href="data[indextr][column]" target="_blank") Descargar
                  vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status_display']}}
                vm-td
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click v-if="$auth.check('User') && data[indextr]['status'] === 1")
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="editLot(data[indextr], tr)")
                      vm-icon(icon="edit-2-outline")
                      slot &nbsp;{{ $t('strings.edit') }}
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click v-if="$auth.check('Admin')")
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="editLot(data[indextr], tr)")
                      vm-icon(icon="edit-2-outline")
                      slot &nbsp;{{ $t('strings.edit') }}
                    //- vm-dropdown-item.d-flex.justify-content-between(@click="imagesLot(data[indextr], tr)")
                      vm-icon(icon="image-outline")
                      slot &nbsp;{{ $t('strings.add_image') }}
                    //- More actions
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ModalLots from '@/components/modals/ModalLots.vue'
import ModalLotsMany from '@/components/modals/ModalLotsMany.vue'
import ModalImagesLots from '@/components/modals/ModalImagesLots.vue'
import ModalImport from '@/components/modals/ModalImport.vue'
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import Loader from '@/components/aditionals/Loader.vue'

import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Lots')

export default {
  name: 'Lots',
  components: {
    ModalLots,
    ModalLotsMany,
    ModalImagesLots,
    ModalImport,
    Loader
  },
  data: () => ({
    currentPage: 1,
    isModalAdd: true,
    newRecord: {},
    ids: [],
    form: {},
    map_id: 1,
    selected: [],
    categories: [],
    ranger: [],
    date: [],
    columns: [
      'id',
      'title',
      'square_meter',
      'park',
      'discount_voucher',
      'category_name',
      'construction_mts',
      'surface_mts',
      'completion_date',
      'status'
    ],
    columnsOrderBy: [
      // Nota solo si las columnas son atributos
      'status',
      'total_cost',
      'title',
      'category_name'
    ],
    status: [
      {
        text: 'Disponible',
        value: 1,
        color: 'success'
      },
      {
        text: 'Vendido',
        value: 2,
        color: 'danger'
      },
      {
        text: 'Vendido Online',
        value: 3,
        color: 'warning'
      },
      {
        text: 'No Disponible',
        value: 4,
        color: 'danger'
      }
    ],
    park: [
      {
        text: 'Si',
        value: 1
      },
      {
        text: 'No',
        value: 0
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        title: '',
        category_name: '',
        completion_date: '',
        discount_voucher: '',
        // user: {
        //  email: ''
        // },
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
        square_meter: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  async created() {
    this.filtersClear = parseVuexObject(this.filters)
    await this.getMaps()
    await this.getLots(1)
    await this.loadCategoriesCatalog()
    await this.getExcedente()
    await this.getDateComplete()
  },
  methods: {
    ...mapActions([
      'deleteLot',
      'deleteLots',
      'loadLots',
      'loadMaps',
      'loadCatalog',
      'getLotsCatalog',
      'loadExcedent',
      'loadDateComplete',
      'loadCategoriesCatalog',
      'actionLot',
      'setModalImportVisible',
      'setModalVisible',
      'setModalLostManyVisible',
      'setModalImagesVisible',
      'editHouse',
      'printReport',
      'applyFilter',
      'clearFilter'
    ]),
    stripHTML(description) {
      return (description && description !== '') && description.replace(/<[^>]+>/g, ' ')
    },
    setFilters() {
      if (this.filters.whereBetween.square_meter.length > 0) {
        let squareMeter = this.filters.whereBetween.square_meter.split(',')
        this.filters.whereBetween.square_meter = squareMeter
      }
      this.applyFilter(this.filters)
    },
    isGarden(lot) {
      return !lot.layer_id.includes('jardin')
    },
    colorStatus(code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    initRange(excedente) {
      this.ranger = []
      const range = Math.ceil(excedente) / 10
      let number = 0
      for (let index = 0; index < 10; index++) {
        this.ranger.push(`${Math.ceil(number + 1)},${Math.ceil(number += range)}`)
      }
    },
    setFocusSearch() {
      this.$refs.search.$refs.vminput.focus()
    },
    editShortcut() {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.lots.findIndex(u => u.id === this.selected[0].id)
      this.editLot(this.selected[0], idx)
    },
    addLot() {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.newRecord = {}
    },
    editLot(lot, index) {
      this.isModalAdd = false
      this.setModalVisible(true)
      this.newRecord = { ...lot }
    },
    inCorner(lot) {
      this.newRecord = { ...lot, park: !lot.park }
      this.editHouse(this.newRecord)
    },
    imagesLot(lot, index) {
      this.isModalAdd = true
      this.setModalImagesVisible(true)
      this.form = { ...lot }
    },
    async deleteLotConfirm(lot) {
      let t = this
      this.auxDeleteLot = () => {
        t.deleteLot(lot).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.lot'), attribute: this.$t(lot.id) }),
        accept: this.auxDeleteLot
      })
    },
    async deleteLotsConfirm() {
      let t = this
      let lotsMany = parseDeleteMany(this.selected, 'id')
      this.auxDeleteLot = () => {
        t.deleteLots(lotsMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.lot'), attribute: lotsMany.values }),
        accept: this.auxDeleteLot
      })
    },
    async setActionLot(record, action) {
      record.id && this.actionLot({ id: record.id, action })
    },
    async getLots(page) {
      let t = this
      this.loadLots({ page, map_id: this.map_id }).then(data => t.getProps(t.$route.params.id))
    },
    async getExcedente() {
      let t = this
      this.loadExcedent({ map_id: this.map_id }).then(data => {
        t.getProps(t.$route.params.id)
        this.initRange(this.excedente)
      })
    },
    async getDateComplete() {
      this.loadDateComplete({ map_id: this.map_id })
    },
    async getMaps(page) {
      this.loadMaps()
    },
    getProps(index) {
      let lot = this.lots.filter(lot => lot.id === parseInt(index))[0]
      lot && this.editLot(lot, index)
    },
    autoCompleteFunc(value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    newObjectFuncModal(value) {
      //
    },
    newObjectFuncView(value) {
      //
    },
    handleChange(range) {
    },
    editMany() {
      this.ids = parseDeleteMany(this.selected, 'id')
      this.setModalLostManyVisible(true)
    },
    resetSelect() {
      this.selected = []
    },
    hiddeDrop() {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    }
  },
  computed: {
    ...mapGetters([
      'lots',
      'maps',
      'models',
      'pagination',
      'filterParams',
      'categoriesCatalog',
      'excedente',
      'dateComplete'

    ]),
    searchPlaceholder() {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, $\{t.$t('lots.' + column)}` : `${str} ${t.$t('lots.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.lot'), columns: concatColumns, column: this.$t('lots.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete() {
      return this.selected.length > 0
    },
    enabledEdit() {
      return this.selected.length > 0
    },
    total() {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage(currentPage) {
      this.getLots(currentPage)
    },
    filterParams(filter) {
      console.log(this.filters.whereBetween.square_meter)
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getLots(this.currentPage)
    },
    map_id(id) {
      this.getLots(1).then(() => {
        this.getExcedente()
        this.getDateComplete()
      })
    },
    lots() {
      this.filters.whereBetween.square_meter = []
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
    position: relative !important;

    .vm-datepicker--calendar.vm-datepicker-primary {
      top: 0 !important;
      left: 0 !important;
    }
  }
}

.con-vm-tooltip {
  display: inline-block;
  position: relative;
}

.vm-table--header {
  padding: 10px;

  span:nth-child(1) {
    width: 100%;
  }

  .input-select-con {
    span {
      width: auto !important;
    }
  }

  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }

      .vm-con-dropdown {
        float: left;
      }

      .con-select {
        display: inline-block;

        input {
          height: 32px;
        }
      }
    }
  }
}

.vm-datepicker--calendar.vm-datepicker-primary {
  left: 38px !important;
  top: 18.7px !important;
}
</style>
